import React from 'react';

interface IHelpCardProps {
  children: React.ReactNode;
  svgIcon?: string;
  iconAlt?: string;
}
interface IHelpCardIconProps {
  svgIcon: string;
  iconAlt: string;
}

function HelpCardIcon({ svgIcon, iconAlt }: IHelpCardIconProps) {

  return (
    <div className="help-card__icon-container">
      <div className="help-card__icon-frame">
        <img
          src={svgIcon}
          alt={iconAlt}
          className="help-card__icon"
        />
      </div>
    </div>
  );
}

export default function HelpCard({
  children,
  svgIcon = null,
  iconAlt = '',
}: IHelpCardProps) {

  return (
    <div className="help-card">
      {svgIcon && (
        <HelpCardIcon
          svgIcon={svgIcon}
          iconAlt={iconAlt}
        />
      )}
      <div className="help-card__content">
        {children}
      </div>
    </div>
  );
}
